export default {

  FM_MEA_1: "Fiche_magasin_MEA_1",
  MOBILE_FM_MEA_1: "Mobile_Fiche_magasin_MEA_1",
  FICHE_MAGASIN_SEO_FOOTER: "Fiche_Magasin_SEO_Footer"
}
